import type { Messages } from '../catalogue.en'

/**
 * The review of a recognized laboratory draft as rows under their print: the
 * crops, report dates, codes and their automatic mark, Needs attention, the
 * unsaved-edits question, and a confirmed report's provenance.
 */
export const laboratoryReview: Partial<Messages> = {
  'lab.review.reportGroup': 'Бланк {number}',
  'lab.review.collectionDate': 'Забор: {when}',
  'lab.review.resultDate': 'Результат: {when}',
  'lab.review.dateMissing': 'Укажите дату забора или результата',
  'lab.review.individualDates': 'Индивидуальные даты',
  'lab.review.editDates': 'Изменить даты этого анализа',
  'lab.review.inheritDates': 'Использовать даты бланка',
  'lab.review.catalogTitle': 'Выбор анализа из справочника',
  'lab.review.catalogMore': 'Загрузить ещё коды',
  'lab.review.codingChoose': 'Выбрать код',
  'lab.review.codingChange': 'Заменить код',
  'lab.review.automatic': 'Автоматически',
  'lab.review.automaticDetail':
    'Код выбран автоматически. Подтверждение отчёта принимает его; чтобы заменить, выберите другой код.',
  'lab.review.codingSearch': 'Поиск в лабораторном каталоге',
  'lab.review.codingClear': 'Убрать код',
  'lab.review.suggestions': 'Предложенные коды',
  'lab.review.attentionConfidence': 'Распознано неуверенно',
  'lab.review.attentionUnmapped': 'Нет кода из каталога',
  'lab.review.attentionAutomatic': 'Автоматический код под сомнением',
  'lab.review.attentionUnplaced': 'Не найдено на странице',
  'lab.review.cropOpen': 'Открыть страницу {page} с выделенной строкой',
  'lab.review.cropMissing': 'На странице {page} не найдено. Открыть страницу',
  'lab.review.cropUnavailable': 'Не удалось показать страницу {page}',
  'lab.review.page': 'Страница {page}',
  'lab.review.addedRows': 'Добавленные строки',
  'lab.review.filterLabel': 'Показанные строки',
  'lab.review.filterAll': 'Все строки: {count}',
  'lab.review.filterAttention': 'Требуют внимания: {count}',
  'lab.review.attentionNone': 'Строк, требующих внимания, нет.',
  'lab.review.unsavedIntent': 'Правки распознанных результатов анализов',
  'lab.review.provenanceTitle': 'Источник отчёта',
  'lab.review.provenanceSource': 'Источник: {name}',
  'lab.review.provenancePages': 'Источник: {name}, страницы {pages}',
  'lab.review.provenancePagesOf': 'Источник: {name}, страницы {pages} из {count}',
  'lab.review.provenanceOpen': 'Открыть',
  'lab.review.provenanceRecognized': 'Распознано {when}',
  'lab.review.provenanceRecognizedBy': 'Распознано {when}: {who}',
  'lab.review.provenanceGoogle': 'Google Document AI',
  'lab.review.provenanceConfirmed': 'Подтверждено {when}',
  'lab.review.provenanceConfirmedBy': 'Подтверждено {when}: {who}',
  'lab.review.provenanceReplaced': 'Заменил отчёт от {when} (повторное распознавание)',
  'lab.review.reRecognized': 'Заменён повторным распознаванием того же документа',
}
